import { SelectionModel } from '@angular/cdk/collections';
import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatPaginator, MatSort, MatTableDataSource, PageEvent, Sort } from '@angular/material';
import { ApplicationService, Content, ContentService, Device, DeviceService } from '../../shared';

@Component({
  templateUrl: 'add-devices.component.html',
  styleUrls: ['../groups/group.css'],
})
export class SubscribeDevicesDialog implements OnInit, AfterViewInit {
  @ViewChild(MatSort) public matsort: MatSort;
  @ViewChild(MatPaginator) public matPaginator: MatPaginator;
  public selectedList: SelectionModel<Device>;
  public devices: Device[];
  public isLoading;
  public search = '';
  public total = 0;
  public timeoutSearch;
  public devicesColumns = [
    'select',
    'onlineCol',
    'nameCol',
    'licenseCol',
    'lastSeenCol',
    'c3versionCol',
  ];

  constructor(
    public dialogRef: MatDialogRef<SubscribeDevicesDialog>,
    private contentService: ContentService,
    private applicationService: ApplicationService,
    private deviceService: DeviceService,
    @Inject(MAT_DIALOG_DATA) public data: { content: Content, isApp: boolean },
  ) { }

  public ngOnInit(): void {
    this.isLoading = true;
    this.devices = [];
    this.selectedList = new SelectionModel<Device>(true, []);
    this.getDevices();
  }
  public ngAfterViewInit() {
    this.matsort.sortChange.subscribe((s: Sort) => {
      if (this.matPaginator) { this.matPaginator.firstPage(); }
      this.getDevices();
    });
  }
  public getDevices() {
    const filters: any = this.getFilters();
    const pi = (this.matPaginator && this.matPaginator.pageIndex) ? this.matPaginator.pageIndex : 0;
    const ps = (this.matPaginator && this.matPaginator.pageSize) ? this.matPaginator.pageSize : 5;
    this.isLoading = true;
    if (this.data.isApp) {
      this.applicationService.getDevicesToSubscribe(this.data.content._id, pi, ps, filters).subscribe((data) => {
        this.isLoading = false;
        if (!this.search) { this.total = data.total; }
        this.setTableData(data.devices, data.total);
      });
    } else {
      this.contentService.getDevicesToSubscribe(this.data.content._id, pi, ps, filters).subscribe((data) => {
        this.isLoading = false;
        if (!this.search) { this.total = data.total; }
        this.setTableData(data.devices, data.total);
      });

    }
  }
  public onNoClick(): void {
    this.dialogRef.close();
  }
  public onYesClick(): void {
    if (this.selectedList && this.selectedList.selected.length) {
      const sel = this.selectedList.selected.map((s) => s._id);
      if (this.data.isApp) {
        this.applicationService
          .subscribeDevicesToApp(this.data.content._id, sel)
          .subscribe((data) => {
            this.dialogRef.close();
          });
      } else {
        this.contentService
          .subscribeDevicesToContent(this.data.content._id, sel)
          .subscribe((data) => {
            this.dialogRef.close();
          });
      }
    }
  }
  public checkChange(checked, row) {
    if (checked) {
      if (!this.selectedList.selected.find((s) => s._id == row._id)) {
        this.selectedList.select(row);
      }
    } else {
      this.selectedList.deselect(row);
      const index = this.selectedList.selected.findIndex((d) => d._id == row._id);
      if (index > -1) { this.selectedList.selected.splice(index, 1); }
    }
  }
  public isChecked(row) {
    return !!this.selectedList.selected.find((s) => s._id == row._id);
  }
  public isAllSelected() {
    return this.selectedList.selected.length === this.total;
  }
  public masterToggle() {
    this.isLoading = true;
    const filters: any = this.getFilters();
    if (this.data.isApp) {
      this.applicationService.getDevicesToSubscribe(this.data.content._id, null, null, filters).subscribe((data) => {
        this.isLoading = false;
        if (this.isAllSelected()) {
          this.selectedList.clear();
        } else {
          data.devices.forEach((row) => {
            if (!this.selectedList.selected.find((s) => s._id == row._id)) {
              // if (row.hasDiskSpace) {
              this.selectedList.select(row);
              // }
            }
          });
        }
      });
    } else {
      this.contentService.getDevicesToSubscribe(this.data.content._id, null, null, filters).subscribe((data) => {
        this.isLoading = false;
        if (this.isAllSelected()) {
          this.selectedList.clear();
        } else {
          data.devices.forEach((row) => {
            if (!this.selectedList.selected.find((s) => s._id == row._id)) {
              this.selectedList.select(row);
            }
          });
        }
      });
    }
  }
  public setTableData(devices: Device[], total: number) {
    this.devices = devices;
    if (this.matPaginator && this.matPaginator.length != total) {
      this.matPaginator.length = total;
    }
  }

  public pageChange(page?: PageEvent) {
    this.matPaginator.pageIndex = page.pageIndex;
    this.matPaginator.pageSize = page.pageSize;
    this.getDevices();
  }
  public searchFn(event) {
    if (!this.search || (event && event.keyCode == 13)) {
      clearTimeout(this.timeoutSearch);
      this.matPaginator.firstPage();
      this.getDevices();
      return;
    }

    if (this.timeoutSearch) {
      clearTimeout(this.timeoutSearch);
    }
    this.timeoutSearch = setTimeout(() => {
      this.matPaginator.firstPage();
      this.getDevices();
    }, 500);
  }
  private getFilters() {
    // const filters: any = { };
    const filters: any = { simple: true };
    if (this.search != undefined) { filters.search = this.search; }
    if (this.search) { filters.search = this.search; }
    if (this.devices && this.matsort && this.matsort.active) {
      filters.sortBy = this.matsort.active + '';
      filters.sortByDir = this.matsort.direction + '';
    } else {
      filters.sortBy = 'onlineCol';
      filters.sortByDir = 'asc';
    }
    return filters;
  }
}
